var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMailSvg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.3,
  d: "m1.166 4.082 4.763 3.334c.386.27.578.405.788.457.185.046.38.046.565 0 .21-.052.402-.187.788-.457l4.763-3.334m-8.867 7.583h6.067c.98 0 1.47 0 1.844-.19a1.75 1.75 0 0 0 .765-.765c.19-.375.19-.865.19-1.845V5.132c0-.98 0-1.47-.19-1.844a1.75 1.75 0 0 0-.765-.765c-.374-.191-.864-.191-1.844-.191H3.966c-.98 0-1.47 0-1.844.19a1.75 1.75 0 0 0-.765.766c-.191.374-.191.864-.191 1.844v3.733c0 .98 0 1.47.19 1.845.169.33.436.597.766.765.374.19.864.19 1.844.19"
})));
export { SvgMailSvg as ReactComponent };
export default __webpack_public_path__ + "assets/images/mailSvg.546386a1c29a1e1e233c046375a07ef6.svg";